import React from "react";
import { Route, Routes } from "react-router";
import PublicRoutes from "../routes/PublicRoutes";
import PrivateRoutes from "../routes/PrivateRoutes";
import { lazy } from "react";
import Account from "../pages/Account";
import OrderListing from "../pages/OrderListing";
import Checkout from "../pages/Checkout";
import OrderPlaced from "../pages/OrderPlaced";
import ViewCategories from "../pages/viewCategory";
import NewPackageOrder from "../pages/parcel/packageType";
import SearchPage from "../pages/SearchPage";
import VendorInfoPage from "../pages/VendorInfo";
const Home = lazy(() => import("../../src/pages/Home"));
const CartContent = lazy(() => import("../../src/components/cart/CartContent"));


const Router = () => {
  return (
    <Routes>
      <Route
        path="/"
        exact
        element={
          <PublicRoutes>
            <Home />
          </PublicRoutes>
        }
      />
      <Route
        path="/account"
        exact
        element={
          <PrivateRoutes>
            <Account />
          </PrivateRoutes>
        }
      />
      <Route
        path="/cart"
        exact
        element={
          <PublicRoutes>
            <CartContent />
          </PublicRoutes>
        }
      />
      <Route
        path="/checkout"
        exact
        element={
          <PrivateRoutes>
            <Checkout />
          </PrivateRoutes>
        }
      />
      <Route
        path="/search"
        exact
        element={
          <PublicRoutes>
            <SearchPage />
          </PublicRoutes>
        }
      />
      <Route
        path="/orderlist"
        exact
        element={
          <PrivateRoutes>
            <OrderListing />
          </PrivateRoutes>
        }
      />
      <Route
        path="/confirmed"
        exact
        element={
          <PublicRoutes>
            <OrderPlaced />
          </PublicRoutes>
        }
      />
      <Route
        path="/vendor-type/:slug/:id"
        exact
        element={
          <PublicRoutes>
            <ViewCategories />
          </PublicRoutes>
        }
      />
      <Route
        path="/vendor-info/:id/:name"
        exact
        element={
          <PublicRoutes>
            <VendorInfoPage />
          </PublicRoutes>
        }
      />

      <Route
        path="/vendor-2"
        exact
        element={
          <PublicRoutes>
            <NewPackageOrder />
          </PublicRoutes>
        }
      />
    </Routes>
  );
};

export default Router;
